/* eslint-disable import/no-cycle */
import styled from 'styled-components';
import Color from './Color';
import { MaxWidth } from './Responsive';

const FullPreview = styled.div`
  min-height: calc(100vh - (576px + 80px));
  background-color: ${({ theme: { colors } }) => colors.gray.light};
  padding: 40px 0 100px 0;
  ${MaxWidth.sm`
    padding: 60px 0;
  `}
`;

const FullPreviewBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.light.primary};
  border-radius: 5px;
  padding: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  > div {
    width: 100%;
  }
  ${MaxWidth.sm`
    padding: 30px 20px;
    text-align: left;
  `}
`;

export { FullPreview, FullPreviewBox };
